export default [
  {
    path: '/member',
    name: 'member',
    component: () => import('@parent/views/member/index.vue'),
  },
  {
    path: '/member-stu-chooser',
    name: 'memberStuChooser',
    component: () => import('@parent/views/member/student-chooser.vue'),
  },
  {
    path: '/member-rights',
    name: 'memberRights',
    component: () => import('@parent/views/member/member-rights.vue'),
  },
  {
    path: '/member-me',
    name: 'memberMe',
    component: () => import('@parent/views/member/me.vue'),
  },
  {
    path: '/member-usermodify',
    name: 'memberUsermodify',
    component: () => import('@parent/views/member/modify.vue'),
  },
  {
    path: '/member-points-records',
    name: 'memberPointsRecords',
    component: () => import('@parent/views/member/points-records.vue'),
  },
  {
    path: '/member-activities',
    name: 'memberActivities',
    component: () => import('@parent/views/member/activity.vue'),
  },
  {
    path: '/member-activity-detail',
    name: 'memberActivityDetail',
    component: () => import('@parent/views/member/activity-detail.vue'),
  },
  {
    path: '/member-rule',
    name: 'member-rule',
    component: () => import('@parent/views/member/rule.vue'),
  },
]